<template>
  <div class="flex-box pl5 pr5 mb10 al-c" :style="compWidth()">
    <div class="tx-r" :style="{ 'width': this.width ? this.width + 'em' : 'auto' }">{{ typeData.label }}：</div>
    <div class="flex-1">
      <el-radio-group v-model="value">
        <el-radio-button v-for="(val, key) in typeData.data" :key="key" :label="val.value" text-color="#475eb7" fill="#475eb7">{{ val.label }}</el-radio-button>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "RadioComp",
  props: ["type-data", "width", "colspan"],
  components: {},
  data() {
    return {
      value:
        this.typeData.value || this.typeData.value == ""
          ? this.typeData.value
          : null
    };
  },
  created() {},
  computed: {},
  mounted() {},
  methods: {
    compWidth() {
      if (this.colspan) {
        if (typeof this.colspan == "number") {
          return { width: this.colspan + "px" };
        } else {
          return { width: this.colspan };
        }
      } else {
        return { width: "33%" };
      }
    }
  }
};
</script>
